<template>
  <div class="mb-3 flex flex-wrap items-center gap-2">
    <a class="btn btn-default inline-flex items-center gap-2" :href="link('csv')" target="_blank" rel="noopener">
      <i class="fa fa-download" aria-hidden="true"></i>
      <span>{{ $t('message.download') }} CSV</span>
    </a>
    <a class="btn btn-default inline-flex items-center gap-2" :href="link('xlsx')" target="_blank" rel="noopener">
      <i class="fa fa-download" aria-hidden="true"></i>
      <span>{{ $t('message.download') }} Excel</span>
    </a>
  </div>
</template>

<script>
import mixins from '../modules/mixins'

export default {
  name: 'DownloadExportButtons',
  mixins: [mixins],
  props: {
    /** API resource path segment, e.g. water-meter, transmitter, gas-meter */
    resource: {
      type: String,
      required: true
    }
  },
  methods: {
    link (format) {
      const orgId = this.activeOrganization && this.activeOrganization.id
      return `/api/v2/${this.resource}?organization=${orgId}&format=${format}&locale=${this.getLanguage()}`
    }
  }
}
</script>
